import ThemeConfig from '../../theme/ThemeConfig'

const reactSelectComponentsStyles = {
  option: base => ({
    ...base,
    width: 'auto',
    fontSize: ThemeConfig.typography.body1.fontSize,
    boxSizing: 'border-box',
    minHeight: 32,
    fontWeight: 400,
    lineHeight: 1.5,
    padding: '6px 16px',
    color: ThemeConfig.typography.body1.color,
    whiteSpace: 'nowrap',
    letterSpacing: '0.00938em',
    '&:hover': {
      textDecoration: 'none',
      cursor: 'pointer',
      backgroundColor: ThemeConfig.palette.defaultGrey.main,
    },
  }),
  dropdownIndicator: base => ({
    ...base,
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  clearIndicator: base => ({
    ...base,
    '&:hover': {
      cursor: 'pointer',
    },
  }),
}

export { reactSelectComponentsStyles }
